import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-130217f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center ga-3" }
const _hoisted_2 = { class: "flex-grow-1 min-w-0" }
const _hoisted_3 = { class: "text-h6 font-weight-bold text-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis text-wrap"
}
const _hoisted_5 = { class: "d-flex flex-wrap align-center ga-1 mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = { class: "d-flex flex-wrap ga-1" }
const _hoisted_8 = { class: "d-flex align-center ga-2 px-2 pt-1 pb-2" }
const _hoisted_9 = { class: "text-subtitle-1 font-weight-bold flex-grow-1" }

import { computed, ref, watch } from "vue";
import { UsuarioDataDTO } from "@/interfaces/Usuario";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import { PartidaJugada, ResultadoPartida } from "@/utils/historialJugador";
import CardPartidaTorneo from "@/components/PartidasTorneo/CardPartidaTorneo.vue";
import avatarSinFoto from "@/assets/icons/sauron-anime.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'CabeceraJugador',
  props: {
    usuario: {},
    partidas: {}
  },
  setup(__props: any) {

const props = __props;

// Solo las de eventos: las amistosas no cuentan para la racha
const racha = computed(() => props.partidas.filter(p => p.origen === "torneo").slice(0, 5));

const partidaAbierta = ref<PartidaJugada | null>(null);
// Pulsando un nick de la tarjeta se va a otro jugador y la vista se reutiliza: el modal no se queda abierto
watch(
  () => props.usuario.idUsuario,
  () => {
    partidaAbierta.value = null;
  }
);

const colorResultado = (resultado: ResultadoPartida) =>
  resultado === "V" ? "success" : resultado === "D" ? "error" : "grey";
const textoResultado = (resultado: ResultadoPartida) =>
  resultado === "V" ? "Victoria" : resultado === "D" ? "Derrota" : "Empate";

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "mb-3 pa-3 text-left",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_avatar, { size: "72" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: _ctx.usuario.imagen || _unref(avatarSinFoto),
                alt: "Avatar",
                cover: ""
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.usuario.nick), 1),
            (_ctx.usuario.faccion?.nombreFaccion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.usuario.faccion.nombreFaccion), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_chip, {
                size: "small",
                color: "primary",
                variant: "tonal",
                "prepend-icon": "mdi-chart-line"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.usuario.puntuacionElo) + " ELO ", 1)
                ]),
                _: 1
              }),
              (_ctx.usuario.clasificacionElo > 0)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "small",
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(_ctx.usuario.clasificacionElo) + " clasificación ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (racha.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(racha.value, (partida) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: partida.clave,
                    size: "small",
                    label: "",
                    link: "",
                    color: colorResultado(partida.resultado),
                    title: `${textoResultado(partida.resultado)} ${partida.propios}-${partida.rival} contra ${partida.nickRival}`,
                    onClick: ($event: any) => (partidaAbierta.value = partida)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(partida.resultado), 1)
                    ]),
                    _: 2
                  }, 1032, ["color", "title", "onClick"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      "model-value": !!partidaAbierta.value,
      "max-width": "480",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (partidaAbierta.value = null))
    }, {
      default: _withCtx(() => [
        (partidaAbierta.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(textoResultado(partidaAbierta.value.resultado)) + " " + _toDisplayString(partidaAbierta.value.propios) + "-" + _toDisplayString(partidaAbierta.value.rival), 1),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    variant: "text",
                    density: "comfortable",
                    "aria-label": "Cerrar",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (partidaAbierta.value = null))
                  })
                ]),
                _createVNode(CardPartidaTorneo, {
                  idUsuario: _ctx.usuario.idUsuario,
                  match: (partidaAbierta.value.original as ViewPartidaTorneoDTO)
                }, null, 8, ["idUsuario", "match"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}
}

})